import { render, staticRenderFns } from "./TaxCategory.vue?vue&type=template&id=25a91834&"
import script from "./TaxCategory.vue?vue&type=script&lang=js&"
export * from "./TaxCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports